import { Injectable } from '@angular/core';
import {Menu} from "../../../types/left-menu.types";

@Injectable({
  providedIn: 'root'
})
export class SubmenuLeftMenuItemService {
  public getSubmenusUrls(submenus: Array<Menu>): Array<string> {
    return submenus.flatMap(submenu => {
      switch (submenu.type) {
        case 'default':
          return [submenu.id];
        case 'sub-menu':
          return this.getSubmenusUrls(submenu.submenu);
        default:
          console.error('handle all types in your switch statement');
          return [];
      }
    });
  }
}
